import { app } from '@/common/api/apiClient'
import { API_ROUTES } from '@/common/constants'
import { insertStringVariables } from '@/common/utils/utils'
import { useQuery } from '@tanstack/react-query'

export type EsgTermsResponse = {
    word: string
    definition: string
}[]

export type EsgProfileResponse = {
    company: {
        asxCode: string
        companyName: string
        securityNameOfficial: string
        logo: {
            url: string
        }
    }
    sys?: {
        publishedAt?: string
    }
    sixthSense: {
        json: any
    }
    tagsCollection: {
        items: {
            tag: string
            isTagPositive: boolean
        }[]
    }
    avoidedCollection?: {
        items: {
            avoided: string
        }[]
    }
    positiveThemesIncludedCollection?: {
        items: {
            positiveThemesIncluded: string
        }[]
    }

    content: any
}

export const useEsgProfile = (securityCode?: string) => {
    return useQuery({
        queryKey: [API_ROUTES.esgProfile, securityCode],
        queryFn: async () =>
            await app.get<EsgProfileResponse>(`${insertStringVariables(API_ROUTES.esgProfile, securityCode || '')}`),
        enabled: !!securityCode,
    })
}

export const useEsgTerms = () => {
    return useQuery({
        queryKey: [API_ROUTES.esgTerms],
        queryFn: async () => await app.get<EsgTermsResponse>(`${API_ROUTES.esgTerms}`),
        enabled: true,
        staleTime: 1000 * 60 * 60,
    })
}
